import { ref } from 'vue'

const ignoreList = ref([])

export function addIgnoreEl(el) {
  ignoreList.value.push(el)
}

export function removeIgnoreEl(el) {
  ignoreList.value = ignoreList.value.filter((it) => it !== el)
}

export function isIgnored(target) {
  return ignoreList.value.some(el => el?.contains(target))
}